import { CheckCircle2, CircleOff, Waypoints } from 'lucide-react'
import type { IntegrationStats } from '../types'

interface Props {
  stats: IntegrationStats
}

export default function IntegrationStatsRow({ stats }: Props) {
  const cards = [
    { label: 'Composio', value: stats.totalComposio, icon: Waypoints },
    { label: 'Ativas na StationZero', value: stats.stationzeroEnabled, icon: CheckCircle2 },
    { label: 'Desativadas', value: stats.stationzeroDisabled, icon: CircleOff },
  ]

  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      {cards.map((card) => {
        const Icon = card.icon
        return (
          <div key={card.label} className="rounded-lg border border-border bg-card p-4">
            <div className="flex items-center justify-between gap-3">
              <p className="text-xs font-medium uppercase text-muted-foreground">{card.label}</p>
              <Icon className="h-4 w-4 text-muted-foreground" />
            </div>
            <p className="mt-2 truncate text-2xl font-semibold text-foreground">{card.value}</p>
          </div>
        )
      })}
    </div>
  )
}
